import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    specs: {
      paddingLeft: 14,
      marginTop: 6,
    },
  };
});

export { useStyles };
